import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if (variation \"hcp-ui-maintenance-mode-vagrant\")}}\n  <MaintenanceMode::OfflineService @serviceName={{t \"vagrant.product-name\"}} />\n{{else}}\n  {{outlet}}\n{{/if}}", {
  moduleName: "vagrant/templates/application.hbs"
});